const extractExtension = (value) => {
  if (!value) {
    return '';
  }

  const match = String(value).trim().match(/(\.[a-z0-9]+)$/i);
  return match ? match[1].toLowerCase() : '';
};

export const getExtensionFromPath = (filePath, fallback = '') => {
  if (!filePath) {
    return fallback;
  }

  const normalizedPath = String(filePath).split('?')[0].split('#')[0];
  return extractExtension(normalizedPath) || fallback;
};

export const getExtensionFromContentDisposition = (contentDisposition, fallback = '') => {
  if (!contentDisposition) {
    return fallback;
  }

  const utf8Match = String(contentDisposition).match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      const decoded = decodeURIComponent(utf8Match[1].trim());
      return extractExtension(decoded) || fallback;
    } catch {
      return fallback;
    }
  }

  const filenameMatch = String(contentDisposition).match(/filename\s*=\s*("?)([^";]+)\1/i);
  if (!filenameMatch?.[2]) {
    return fallback;
  }

  return extractExtension(filenameMatch[2]) || fallback;
};

export const getDownloadExtension = ({ filePath, contentDisposition, fallback = '.pdf' } = {}) => {
  const extensionFromPath = getExtensionFromPath(filePath, '');
  if (extensionFromPath) {
    return extensionFromPath;
  }

  return getExtensionFromContentDisposition(contentDisposition, fallback);
};
